import { lazy, Suspense } from 'react';
import SVG from 'Components/UI/SVG';

type DynamicSVGProps = {
  fileName: string;
  assetsDirectory?: string;
  clickHandler?: (event: React.MouseEvent) => void;
};

const DynamicSVG = ({
  fileName,
  assetsDirectory = '',
  clickHandler,
}: DynamicSVGProps): JSX.Element => {
  if (!fileName) {
    return <></>;
  }

  const Component = lazy(() =>
    import(`Assets/${assetsDirectory}${fileName}.svg`).then((module) => ({
      default: () => (
        <SVG src={module.default} name={fileName} clickHandler={clickHandler} />
      ),
    })),
  );

  return (
    <Suspense>
      <Component />
    </Suspense>
  );
};

export default DynamicSVG;
